import React from "react";

class Invoice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: props.invoice,
        };
    }

    render() {
        return (
            <div className='invoice-preview'>
                <h4>{this.state.invoice.invoiceNumber + ' - számla részletei'}</h4>
                <div className="row">
                    <div className="col-4">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="font-weight-bold" colSpan="2">Szállító</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><label>Cég neve</label></td>
                                <td><span>{this.state.invoice.supplier.name}</span></td>
                            </tr>
                            <tr>
                                <td><label>Adószám</label></td>
                                <td><span>{this.state.invoice.supplier.taxNumber || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Cím</label></td>
                                <td><span>{this.state.invoice.supplier.addressTitle || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Bankszámlaszám</label></td>
                                <td><span>{this.state.invoice.supplier.bankAccountNumber || '-'}</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="col-4">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="font-weight-bold" colSpan="2">Paraméterek</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><label>Fizetési mód</label></td>
                                <td><span>{this.state.invoice.paymentMethodLabel || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Teljesítés dátuma</label></td>
                                <td><span>{this.state.invoice.invoiceDeliveryDate || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Kiállítás dátuma</label></td>
                                <td><span>{this.state.invoice.invoiceIssueDate || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Fizetési határidő</label></td>
                                <td><span>{this.state.invoice.invoicePaymentDate || '-'}</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="col-4">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="font-weight-bold" colSpan="2">Vevő</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><label>Cég neve</label></td>
                                <td><span>{this.state.invoice.customer.name}</span></td>
                            </tr>
                            <tr>
                                <td><label>Adószám</label></td>
                                <td><span>{this.state.invoice.customer.taxNumber || '-'}</span></td>
                            </tr>
                            <tr>
                                <td><label>Cím</label></td>
                                <td><span>{this.state.invoice.customer.addressTitle || '-'}</span></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th className="font-weight-bold">Tételek</th>
                        <th className="text-right">Mennyiség</th>
                        <th className="text-right">Áfakulcs</th>
                        <th className="text-right">Nettó ár</th>
                        <th className="text-right">Áfaérték</th>
                        <th className="text-right">Bruttó ár</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.invoice.items.map((item, itemIndex) => {
                        return (
                            <tr key={itemIndex}>
                                <td>{item.name}</td>
                                <td className="text-right">{item.quantity + ' ' + (item.unitLabel || '')}</td>
                                <td className="text-right">{Number(item.vatPercentage * 100).toFixed(2)}%</td>
                                <td className="text-right">{Number(item.lineNetAmountHUF).toFixed(2)}</td>
                                <td className="text-right">{Number(item.lineVatAmountHUF).toFixed(2)}</td>
                                <td className="text-right">{Number(item.lineNetAmountHUF + item.lineVatAmountHUF).toFixed(2)}</td>
                            </tr>
                        )
                    })}
                    </tbody>
                    <tfoot>
                    <tr className="font-weight-bold">
                        <td colSpan="3">Összesen</td>
                        <td className="text-right">{Number(this.state.invoice.invoiceNetAmountHUF).toFixed(2)}</td>
                        <td className="text-right">{Number(this.state.invoice.invoiceVatAmountHUF).toFixed(2)}</td>
                        <td className="text-right">{Number(parseFloat(this.state.invoice.invoiceNetAmountHUF) + parseFloat(this.state.invoice.invoiceVatAmountHUF)).toFixed(2)}</td>
                    </tr>
                    </tfoot>
                </table>


                <div className="row">
                    <div className="col-4">
                    </div>
                    <div className="col-4">
                        {this.state.invoice.currency !== 'HUF'
                            ? <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th className="font-weight-bold" colSpan="2">Deviza összesítő</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Árfolyam</td>
                                    <td className="text-right">{Number(this.state.invoice.exchangeRate).toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td>Nettó</td>
                                    <td className="text-right">{Number(this.state.invoice.invoiceNetAmount).toFixed(2)} {this.state.invoice.currency}</td>
                                </tr>
                                <tr>
                                    <td>ÁFA</td>
                                    <td className="text-right">{Number(this.state.invoice.invoiceVatAmount).toFixed(2)} {this.state.invoice.currency}</td>
                                </tr>
                                <tr className="font-weight-bold">
                                    <td>Bruttó</td>
                                    <td className="text-right">{Number(parseFloat(this.state.invoice.invoiceNetAmount) + parseFloat(this.state.invoice.invoiceVatAmount)).toFixed(2)} {this.state.invoice.currency}</td>
                                </tr>
                                </tbody>
                            </table>
                            : null
                        }
                    </div>
                    <div className="col-4">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th className="font-weight-bold" colSpan="2">Összesítő</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Deviza</td>
                                <td className="text-right">{this.state.invoice.currency}</td>
                            </tr>
                            <tr>
                                <td>Nettó</td>
                                <td className="text-right">{Number(this.state.invoice.invoiceNetAmountHUF).toFixed(2)} Ft</td>
                            </tr>
                            <tr>
                                <td>ÁFA</td>
                                <td className="text-right">{Number(this.state.invoice.invoiceVatAmountHUF).toFixed(2)} Ft</td>
                            </tr>
                            <tr className="font-weight-bold">
                                <td>Bruttó</td>
                                <td className="text-right">{Number(parseFloat(this.state.invoice.invoiceNetAmountHUF) + parseFloat(this.state.invoice.invoiceVatAmountHUF)).toFixed(2)} Ft</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}


export default Invoice


// WEBPACK FOOTER //
// ./src/components/nav/invoice.js